import { render, staticRenderFns } from "./OrganizationTabInformation.vue?vue&type=template&id=ca98179a"
import script from "./OrganizationTabInformation.vue?vue&type=script&lang=js"
export * from "./OrganizationTabInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports